import { registerPlugin } from '@capacitor/core';

export interface SharedKeychainTokens {
  accessToken: string | null;
  refreshToken: string | null;
}

export interface SharedKeychainPlugin {
  getTokens(): Promise<SharedKeychainTokens>;
  setTokens(tokens: SharedKeychainTokens): Promise<void>;
  clearTokens(): Promise<void>;
}

const SharedKeychain = registerPlugin<SharedKeychainPlugin>('SharedKeychain');

export default SharedKeychain;
